"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGroupedOptionArray = exports.convertGroupedOptionToCategory = void 0;
const convertGroupedOptionToCategory = (option) => ({
    id: option.value,
    children: option.children ? option.children.map((child) => child.value) : undefined,
});
exports.convertGroupedOptionToCategory = convertGroupedOptionToCategory;
// Type guard to check if an object is a GroupedOption
const isGroupedOptionArray = (arr) => arr.length > 0 && typeof arr[0] === 'object' && arr[0] !== null && 'label' in arr[0];
exports.isGroupedOptionArray = isGroupedOptionArray;
